<template>
  <div>{{ value }}</div>
</template>

<script>
export default {
  name: "define",
  props: {
    value: String,
  },
};
</script>
